import { render, staticRenderFns } from "./Contatti.vue?vue&type=template&id=6288a6e4"
import script from "./Contatti.vue?vue&type=script&lang=js"
export * from "./Contatti.vue?vue&type=script&lang=js"
import style0 from "./Contatti.vue?vue&type=style&index=0&id=6288a6e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports